import {Stack, styled} from '@mui/material';

const StyledContainer = styled(Stack)`
	width: 100%;
	height: 100%;
	padding: 32px;
`;

export {StyledContainer};
